import { Flex } from "@chakra-ui/react";

export default function ActionBox(props) {
  return <Flex mx="14px" mb="12px" {...props}></Flex>;
}
